import "./LeftNavButton.css";

function LeftNavButton({
  text,
  icon,
  slideNumber,
  iconClassName = "",
  caseTitle,
}) {
  return (
    <div className="LeftNavButtonContainer">
      <button
        className="LeftNavButtonBody"
        onClick={() => goToElement(slideNumber)}
      >
        {text}
        <span className={"LeftNavIconContainer " + iconClassName}>{icon}</span>
        <div className="CaseTitle">{caseTitle}</div>
      </button>
    </div>
  );
}

export function goToElement(id) {
  const element = document.getElementById(id);
  element.scrollIntoView({ behavior: "smooth", block: "center" });
}

export default LeftNavButton;
